import classnames from 'classnames/bind'
import React from 'react'

import BoxColumnImageText, {
  BoxColumnImageTextProps,
} from '~/components/BoxColumnImageText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoColumnImageTextProps {
  className?: string
  horizontal?: boolean
  firstBox?: BoxColumnImageTextProps
  secondBox?: BoxColumnImageTextProps
}

function EditoColumnImageText({
  className,
  horizontal,
  firstBox,
  secondBox,
}: EditoColumnImageTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  return (
    <div className={cx(css.EditoColumnImageText, className)}>
      <div className={cx(css.grid, gridStyle)}>
        <div className={cx(css.content, { isHorizontal: horizontal })}>
          {firstBox && (
            <BoxColumnImageText
              className={cx(css.box, css.firstBox)}
              horizontal={horizontal}
              {...firstBox}
            />
          )}
          {secondBox && (
            <BoxColumnImageText
              className={cx(css.box, css.secondBox)}
              horizontal={horizontal}
              {...secondBox}
            />
          )}
        </div>
      </div>
    </div>
  )
}

EditoColumnImageText.defaultProps = {}

export default EditoColumnImageText
